export const processCDN = cdn => ({
  id: cdn.id,
  name: cdn.name,
  state: cdn.state,
  whitelist: cdn.ip_whitelist,
  disabled: cdn.disabled || false,
});

export const processElem = elem => ({
  id: elem.channel.id,
  name: elem.channel.name,
  token: elem.token,
  urls: elem.urls,
});

export const processChannelDistribution = (cd) => {
  const processed = {
    id: cd.id,
    extId: cd.ext_id,
    createTime: cd.create_time,
    updateTime: cd.update_time,
    name: cd.name,
    cdn: {},
    channels: [],
    urls: [],
  };
  if (cd.cdn) {
    processed.cdn = processCDN(cd.cdn);
  }
  if (cd.elems) {
    processed.channels = cd.elems.map(c => processElem(c));
  }
  return processed;
};

export const channelDistributionToJsonAPI = (cd) => {
  const processed = {
    id: cd.id,
    name: cd.name,
    cdn: {},
    channels: [],
  };
  if (cd.cdn) {
    processed.cdn = { id: cd.cdn };
  }
  if (cd.channels) {
    processed.elems = cd.channels.map(c => ({ channel: { id: c } }));
  }
  return processed;
};

export const processWatchFolderOutput = o => ({
  id: o.id,
  createTime: o.create_time,
  updateTime: o.update_time,
  name: o.name,
  format: o.format,
  urls: o.url,
  zip: o.zip || '',
  drm: o.drm || '',
  segmentSize: o.segment_size,
  hlsVersion: o.hls_version,
  widevine: {
    licenseServer: o.widevine_license_server || '',
    provider: o.widevine_provider || '',
    key: o.widevine_key || '',
    iv: o.widevine_iv || '',
    packageName: o.widevine_package_name || '',
  },
  playready: {
    licenseServerURL: o.playready_la_url || '',
    kidUUID: o.playready_key_id || '',
    keySeed: o.playready_key_seed || '',
    cekB64: o.playready_content_key || '',
  },
});

export const processProfile = profile => ({
  id: profile.id,
  name: profile.name,
  audioTemplate: profile.audio_template,
  videoTemplate: profile.video_template,
});

export const processWatchFolder = (wf) => {
  const processed = {
    id: wf.id,
    createTime: wf.create_time,
    updateTime: wf.update_time,
    state: wf.state,
    error: wf.error,
    name: wf.name,
    url: wf.url,
    profile: processProfile(wf.profile),
    outputs: [],
    once: wf.once,
    closed: wf.closed,
  };
  if (wf.outputs) {
    processed.outputs = wf.outputs.map(o => processWatchFolderOutput(o));
  }
  return processed;
};

export const DVRChannelFormToJsonAPI = (dc) => {
  const t = + new Date();
  const processed = {
    id: dc.id,
    name: dc.name,
    ext_id: `${t}:${dc.name}`,
    input_url: '',
    duration: Number(dc.duration.days) * 86400 + Number(dc.duration.hours) * 3600,
  };
  if (dc.sourceType === 'channel') {
    processed.input_url = dc.channelSource;
    const bitrateInd = [];
    for (let i = 0; i < dc.bitrates.length; i += 1) {
      bitrateInd.push(dc.bitrates[i].index);
    }
    processed.input_url += `?hls.variants=${bitrateInd.join(',')}`;
  } else if (dc.sourceType === 'newSource') {
    processed.input_url = dc.newSource;
  }
  return processed;
};

export const processDVRChannel = dc => ({
  id: dc.id,
  extId: dc.ext_id,
  name: dc.name,
  createTime: dc.created,
  updateTime: dc.updated,
  state: dc.state,
  error: dc.error,
  inputURL: dc.input_url,
  duration: dc.duration,
  hls3URL: dc.hls3_url,
  hls5URL: dc.hls5_url,
  hls7URL: dc.hls7_url,
  dashURL: dc.dash_url,
  mp4URL: dc.mp4_url,
});
